import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import heroBg from '../assets/kgl.jpg'; // Local hero image
import kgBg from '../assets/kgl-2.jpg'; // Local hero image
import gas from '../assets/gas.jpg'; // Local hero image
import realEstate from '../assets/real-estate.jpg'; // Local hero image
import farm from '../assets/farm-1.jpg'; // Local hero image
import wisp from '../assets/wisp.jpg'; // Local hero image

export default function KGLHome() {
    const heroRef = useRef(null);
  const sectionsRef = useRef([]);
  
  useEffect(() => {
      gsap.from(heroRef.current, {
          opacity: 0.95,
          y: -60,
          duration: 2.2,
      ease: 'power3.out'
    });
    
    sectionsRef.current.forEach((el, i) => {
        gsap.registerPlugin(ScrollTrigger);
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        opacity: 1,
        y: 40,
        duration: 1,
        delay: i * 0.2
      });
    });
  }, []);

  const sections = [
    {
      id: 'gas',
      title: 'KGL Gas',
      desc: 'Supplying families and businesses with clean cooking gas and accessories.',
      image: gas
    },
    {
      id: 'farm',
      title: 'KGL Farms',
      desc: 'Growing and delivering fresh, healthy farm products.',
      image: farm
    },
    {
      id: 'logistics',
      title: 'KGL Logistics',
      desc: 'Reliable transportation and delivery services across regions.',
      image: kgBg
    },
    {
      id: 'realestate',
      title: 'KGL Real Estate',
      desc: 'Developing affordable and luxurious housing for the future.',
      image: realEstate
    },
    {
      id: 'wisp',
      title: 'KGL Connect (WISP)',
      desc: 'Bringing the internet to underserved communities.',
      image: wisp
    }
  ];

  return (
    <div className="bg-white text-gray-800 font-sans">
      <header className="bg-blue-900 text-white p-6 shadow-xl sticky top-0 z-50">
        <div className="container mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold">
            <a href="#" className="hover:underline">KGL Ltd</a>
            </h1>
          <nav className="space-x-4 text-sm">
            <a href="#gas" className="hover:underline">Gas</a>
            <a href="#farm" className="hover:underline">Farm</a>
            <a href="#logistics" className="hover:underline">Logistics</a>
            <a href="#realestate" className="hover:underline">Real Estate</a>
            <a href="#wisp" className="hover:underline">WISP</a>
          </nav>
        </div>
      </header>

      <section
        ref={heroRef}
        className="h-screen flex items-center justify-center text-white bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="text-center px-6 bg-black bg-opacity-50 p-6 rounded-xl">
          <h2 className="text-4xl md:text-6xl font-bold mb-4">Welcome to Kopnan Global Logistics Ltd</h2>
          <p className="text-lg md:text-2xl">Empowering Lives Through Innovation & Infrastructure</p>
        </div>
      </section>

      <main className="space-y-20 py-16 px-6 max-w-6xl mx-auto">
        {sections.map((section, i) => (
          <section
            id={section.id}
            key={section.id}
            ref={el => (sectionsRef.current[i] = el)}
            className="bg-white p-10 rounded-2xl shadow-lg text-center border"
          >
            <img
              src={section.image}
              alt={section.title}
              className="mx-auto mb-6 h-48 w-full object-cover rounded-xl shadow-md"
            />
            <h3 className="text-3xl font-bold text-blue-900 mb-4">{section.title}</h3>
            <p className="text-lg text-gray-700">{section.desc}</p>
          </section>
        ))}
      </main>

      <footer className="bg-blue-900 text-white text-center p-6 mt-20">
        <p>&copy; {new Date().getFullYear()} Kopnan Global Logistics Ltd. All rights reserved.</p>
      </footer>
    </div>
  );
}